import { reducer as appReducer } from 'js/components/system/App/store/reducer';
import { reducer as userReducer } from 'js/hooks/user/store/reducer';
import { reducer as i18nReducer } from 'js/hooks/i18n/store/reducer';
import { reducer as authReducer } from 'js/hooks/auth/store/reducer';
import { reducer as deviceReducer } from 'js/hooks/device/store/reducer';
import { reducer as pageReducer } from 'js/components/system/Page/store/reducer';
import { reducer as jackpotsReducer } from 'js/hooks/useGetJackpots/store/reducer';
import { reducer as paymentsReducer } from 'js/hooks/payments/store/reducer';
import { reducer as gamesConfigurationReducer } from 'js/hooks/games/store/reducer';
import { reducer as loyaltyPointsReducer } from 'js/hooks/loyaltyPoints/store/reducer';
import { reducer as popupsReducer } from 'js/components/common/PopupManager/store/reducer';
import { reducer as termsConditionsReducer } from 'js/hooks/termsConditions/store/reducer';
import { reducer as socketReducer } from 'js/hooks/socket/hooks/useOAPISocket/store/reducer';
import { reducer as liveGamesReducer } from 'js/hooks/useLiveGamesIntegration/store/reducer';
import { reducer as promotionsConfigurationReducer } from 'js/hooks/promotions/store/reducer';
import { reducer as cookieSettingsReducer } from 'js/components/main/CookieSettings/store/reducer';
import { reducer as myAccountSidebarReducer } from 'js/components/main/MyAccountSidebar/store/reducer';
import { reducer as formsReducer } from 'js/components/common/ChangeForm/hooks/useGetForms/store/reducer';
import { reducer as communicationWidgetsReducer } from 'js/components/system/CommunicationWidgets/store/reducer';
import { reducer as sportsbookReducer } from 'js/components/system/App/hooks/useSportsbookIntegration/store/reducer';
import { reducer as lottoReducer } from 'js/components/system/App/hooks/useLottoIntegration/store/reducer';
import { reducer as casinoComponentReducer } from 'js/components/main/CasinoComponent/store/reducer';
import { reducer as gameLaunchReducer } from 'js/hooks/useGameLaunch/store/reducer';

import * as Types from './types';
import * as constants from './constants';

export const staticReducers = {
    [constants.APP_REDUCER]: appReducer,
    [constants.USER_REDUCER]: userReducer,
    [constants.PAGE_REDUCER]: pageReducer,
    [constants.AUTH_REDUCER]: authReducer,
    [constants.I18N_REDUCER]: i18nReducer,
    [constants.FORMS_REDUCER]: formsReducer,
    [constants.LOTTO_REDUCER]: lottoReducer,
    [constants.DEVICE_REDUCER]: deviceReducer,
    [constants.SOCKET_REDUCER]: socketReducer,
    [constants.JACKPOTS_REDUCER]: jackpotsReducer,
    [constants.PAYMENTS_REDUCER]: paymentsReducer,
    [constants.LIVE_GAMES_REDUCER]: liveGamesReducer,
    [constants.SPORTSBOOK_REDUCER]: sportsbookReducer,
    [constants.GAME_LAUNCH_REDUCER]: gameLaunchReducer,
    [constants.LOYALTY_POINTS_REDUCER]: loyaltyPointsReducer,
    [constants.COOKIE_SETTINGS_REDUCER]: cookieSettingsReducer,
    [constants.TERMS_CONDITIONS_REDUCER]: termsConditionsReducer,
    [constants.CASINO_COMPONENT_REDUCER]: casinoComponentReducer,
    [constants.MY_ACCOUNT_SIDEBAR_REDUCER]: myAccountSidebarReducer,
    [constants.GAMES_CONFIGURATION_REDUCER]: gamesConfigurationReducer,
    [constants.COMMUNICATION_WIDGETS_REDUCER]: communicationWidgetsReducer,
    [constants.PROMOTIONS_CONFIGURATION_REDUCER]: promotionsConfigurationReducer,
    [constants.POPUPS_REDUCER]: popupsReducer as Types.TCommonReducer
};
